import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly defaultLanguage = 'es';
  private readonly supportedLanguages = ['en', 'es'];

  /**
   * Get browser language
   * @returns Browser language code (e.g., 'en', 'es')
   */
  getBrowserLanguage(): string {
    // TODO: Remove hardcoded language when implementing language selector
    // For now, always return Spanish
    return 'es';

    // Original implementation (commented out):
    // const browserLang = navigator.language || (navigator as any).userLanguage;
    // const langCode = browserLang.split('-')[0].toLowerCase();
    // return this.supportedLanguages.includes(langCode) ? langCode : this.defaultLanguage;
  }

  /**
   * Get current language
   * @returns Current language code
   */
  getCurrentLanguage(): string {
    return this.getBrowserLanguage();
  }
}
